"use strict";
// import React from 'react'
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiCard = KpiCard;
// export function KpiCard({ label, value, sub, delta }: { label: string; value: string | number; sub?: string; delta?: number | null }) {
//   return (
//     <div className="item-stat-dashboad-view shadow" style={{ height: '100%' }}>
//       <div className="label">{label}</div>
//       {typeof delta === 'number' ? <div className={'delta ' + (delta > 0 ? 'up' : 'down')}>{delta > 0 ? '▲' : '▼'} {Math.abs(delta)}%</div> : <div></div>}
//       <div className="value">{value}</div>
//       <div className="small">{sub}</div>
//     </div>
//   )
// }
const react_1 = __importDefault(require("react"));
/** Couleurs selon la tendance : up / down / neutre */
function palette(delta) {
    if (typeof delta === 'number') {
        if (delta > 0) {
            return {
                bg: 'linear-gradient(135deg, rgba(16,185,129,0.20) 0%, rgba(16,185,129,0.06) 100%)',
                border: 'rgba(16,185,129,0.45)',
                chipBg: 'rgba(16,185,129,0.15)',
                chipText: '#10b981'
            };
        }
        if (delta < 0) {
            return {
                bg: 'linear-gradient(135deg, rgba(244,63,94,0.20) 0%, rgba(244,63,94,0.06) 100%)',
                border: 'rgba(244,63,94,0.45)',
                chipBg: 'rgba(244,63,94,0.15)',
                chipText: '#f43f5e'
            };
        }
    }
    // neutre
    return {
        bg: 'linear-gradient(135deg, rgba(59,130,246,0.20) 0%, rgba(59,130,246,0.06) 100%)',
        border: 'rgba(59,130,246,0.45)',
        chipBg: 'rgba(59,130,246,0.15)',
        chipText: '#60a5fa'
    };
}
function KpiCard({ label, value, sub, delta }) {
    const theme = palette(delta);
    const cardStyle = {
        background: 'linear-gradient(135deg, rgba(30,64,175,0.9), rgba(59,130,246,0.75))',
        borderRadius: 14,
        padding: 14,
        color: '#f8fafc', // texte blanc pur
    };
    const labelStyle = {
        fontSize: 12,
        fontWeight: 500,
        color: 'rgba(248,250,252,0.85)', // presque blanc mais lisible
    };
    const valueRow = {
        display: 'flex',
        alignItems: 'baseline',
        gap: 8
    };
    const valueStyle = {
        fontSize: 26,
        fontWeight: 800,
        color: '#ffffff',
    };
    const chipStyle = {
        background: 'rgba(220,38,38,0.15)', // rouge clair
        color: '#dc2626',
        border: '1px solid #dc2626',
        borderRadius: 999,
        padding: '2px 8px',
        fontSize: 12,
        fontWeight: 700,
    };
    const subStyle = {
        fontSize: 12,
        color: 'rgba(230,234,242,0.7)',
        marginTop: 2
    };
    // Icône simple ↑ / ↓ / •
    const arrow = typeof delta === 'number'
        ? delta > 0
            ? '▲'
            : delta < 0
                ? '▼'
                : '•'
        : '•';
    // Formattage delta (abs, max 1 décimale)
    const deltaText = typeof delta === 'number'
        ? `${Math.abs(delta).toLocaleString('fr-FR', {
            maximumFractionDigits: 1
        })}%`
        : '';
    return (react_1.default.createElement("div", { className: "item-stat-dashboad-view shadow", style: cardStyle },
        react_1.default.createElement("div", { style: labelStyle }, label),
        react_1.default.createElement("div", { style: valueRow },
            react_1.default.createElement("div", { style: valueStyle }, value),
            typeof delta === 'number' ? (react_1.default.createElement("div", { style: chipStyle, "aria-label": `Variation ${delta >= 0 ? 'positive' : 'négative'}` },
                react_1.default.createElement("span", { "aria-hidden": true }, arrow),
                " ",
                deltaText)) : (react_1.default.createElement("span", null))),
        react_1.default.createElement("div", { style: {
                alignSelf: 'stretch',
                height: 6,
                borderRadius: 999,
                background: 'rgba(255,255,255,0.08)',
                overflow: 'hidden',
                marginTop: 4
            } },
            react_1.default.createElement("div", { style: {
                    height: '100%',
                    width: `${Math.max(6, Math.min(100, typeof delta === 'number' ? Math.abs(delta) : 42))}%`,
                    background: 'linear-gradient(90deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.25) 100%)'
                } })),
        sub ? react_1.default.createElement("div", { style: subStyle }, sub) : react_1.default.createElement("div", { style: { height: 0 } })));
}
